<div class="counter-input__text" *ngIf="layoutFormat !== 'stopovers'" aria-hidden="true" [attr.aria-label]="label + ': ' + description + '. ' + _counterValue + ' selected'">
    <label class="label">{{_counterValue + ' ' + label}}</label>
    <label class="description">{{description}}</label>
</div>

<button class="counter-input__sub" [ngClass]="{'not-available': INDRA_disableDecrement(passengerType) == true }" (click)="decrement()" [attr.aria-label]="'Remove ' + label">
    <app-svg aria-hidden="true" classes="counter-input__icon" [svg]="'icons.svg#general--minus_big'" [alt]="'Remove icon'"></app-svg>
</button>
<ng-container *ngIf="layoutFormat === 'stopovers'">
    <div class="counter-input__value">
        <input type="number" [(ngModel)]="counterValue" [max]="max" [min]="min" [readonly]="true">
    </div>
</ng-container>
<button class="counter-input__add" [ngClass]="{'not-available': INDRA_disableIncrement(passengerType) == true }" (click)="increment()" [attr.aria-label]="'Add ' + label">
    <app-svg aria-hidden="true" classes="counter-input__icon" [svg]="'icons.svg#general--plus_big'" [alt]="'Add icon'"></app-svg>
</button>

<span tabindex="-1" role="alert" aria-atomic="true" class="visuallyhidden helper-accessible">{{typePassengersAriaAlert}}</span>